<template>
  <div class="m-approval-container">
    <div class="m-approval-content">
      <!-- 数据表格 -->
      <el-card class="m-card" shadow="hover">
        <el-table
          :data="rejectInfoList"
          border
          size="small"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        >
          <el-table-column prop="whNo" label="DC" min-width="100" align="center" />
          <el-table-column prop="sapNo" label="订单号" min-width="80" align="center" />
          <el-table-column prop="deliveryNo" label="Delivery号" min-width="100" align="center" />
          <el-table-column prop="rejectStatusName" label="单据状态" min-width="80" align="center" />
          <el-table-column prop="approveResultNo" label="审批状态" min-width="80" align="center" />
          <el-table-column prop="receiveDate" label="发货日期" min-width="80" align="center" />
          <el-table-column prop="customerSignTime" label="客户签收时间" min-width="80" align="center" />
          <el-table-column prop="soldtoNo" label="客户编号" min-width="80" align="center" />
          <el-table-column prop="soldtoName" label="客户名称" min-width="80" align="center" />
          <el-table-column prop="rejectOldProductNo" label="拒收品项旧代码" min-width="80" align="center" />
          <el-table-column prop="rejectQty" label="拒收数量" min-width="80" align="center" />
          <el-table-column prop="rejectReasonNo" label="拒收原因类型" min-width="80" align="center" />
          <el-table-column prop="rejectReasonName" label="拒收原因" min-width="80" align="center" />
          <el-table-column prop="rejectReasonExplanation" label="实际拒收原因" min-width="80" align="center" />
          <el-table-column prop="carrierCode" label="承运商" min-width="80" align="center" />
        </el-table>
      </el-card>
    </div>
    <!-- 审批确认 -->
    <el-card class="m-card" shadow="hover">
      <div slot="header" class="m-card-header">
        <span class="m-card-title">审批确认</span>
      </div>
      <el-form ref="approvalForm" :model="approvalForm" label-width="100px" class="m-approval-form">
        <el-form-item label="审批结果">
          <el-radio-group v-model="approvalForm.approveResultNo" :disabled="isEditFlag">
            <el-radio label="10">审批通过</el-radio>
            <el-radio label="99">审批拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见">
          <el-input
            v-model="approvalForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入审批意见"
            :disabled="isEditFlag"
          />
        </el-form-item>
      </el-form>
    </el-card>

    <div class="m-approval-footer" v-if="!isEditFlag">
      <el-button type="primary" size="medium" @click="handleApprove">审批确认</el-button>
    </div>
  </div>
</template>

<script>
import rejectApprovalShowMixins from "./mixins";
export default {
  name: "rejectApprovalShow",
  mixins: [rejectApprovalShowMixins],
  computed: {
    resp() {
      return this.$store.state[this.modName].pageResp;
    },
    total() {
      return this.$store.state[this.modName].total;
    },
  },
  data() {
    return {
      store: "rejectApprovalShow/",
      modName: "rejectApprovalShow",
      pageRequest: { limit: this.$globalLimit, page: this.$globalPage },
      rejectInfoList:[],
      //当前页面是否审批完成
      isEditFlag: false,
      approvalForm:{},
      currentApprover: null//当前审批人
    };
  },
};
</script>
<style lang="scss" scoped>
$primary-color: #1890ff;
$bg-color: #f5f5f5;
$text-primary: #333;
$text-secondary: #666;
$text-label: #999;
$border-color: #eee;
$white: #fff;

.m-approval-container {
  min-height: 100vh;
  background: $bg-color;
  padding: 1rem;
  padding-bottom: 5rem;
  box-sizing: border-box;
}
.m-card {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  ::v-deep .el-card__header {
    padding: 0.8rem 1rem;
    background: rgba($primary-color, 0.05);
    border-bottom: 1px solid $border-color;
  }
}

.m-card-header {
  display: flex;
  align-items: center;
}

.m-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: $text-primary;
}

.m-info-item {
  display: flex;
  align-items: flex-start;
  padding: 0.6rem 0;
  border-bottom: 1px solid rgba($border-color, 0.5);
  &:last-child {
    border-bottom: none;
  }
}

.m-info-label {
  font-size: 0.85rem;
  color: $text-label;
  min-width: 7rem;
  flex-shrink: 0;
  padding-top: 0.1rem;
}

.m-info-value {
  font-size: 0.9rem;
  color: $text-primary;
  word-break: break-all;
  line-height: 1.4;
  display: flex;
  align-items: center;
}

.m-approval-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.8rem 1rem;
  background: $white;
  display: flex;
  justify-content: center;
  box-shadow: 0 -0.1rem 0.5rem rgba(0, 0, 0, 0.05);
  z-index: 100;
  .el-button {
    width: 200px;
  }
}

@media screen and (max-width: 768px) {
  .m-approval-footer {
    .el-button {
      width: 100%;
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .m-approval-container {
    padding: 0.5rem;
    padding-bottom: 4.5rem;
  }
  .m-card {
    margin-bottom: 0.8rem;
    border-radius: 0.4rem;
    ::v-deep .el-card__header {
      padding: 0.6rem 0.8rem;
    }
    ::v-deep .el-card__body {
      padding: 0.5rem 0.8rem;
    }
  }
  .m-info-item {
    padding: 0.5rem 0;
  }
  .m-info-label {
    font-size: 0.8rem;
    min-width: 8rem;
    line-height: 1.4;
  }
  .m-info-value {
    font-size: 0.85rem;
  }
  .m-approval-footer {
    padding: 0.6rem 0.8rem;
  }
}

@media screen and (max-width: 375px) {
  .m-card {
    ::v-deep .el-card__header {
      padding: 0.5rem 0.6rem;
    }
    ::v-deep .el-card__body {
      padding: 0.4rem 0.6rem;
    }
  }
  .m-card-title {
    font-size: 0.9rem;
  }
}
</style>

<style lang="scss">
.m-confirm-dialog {
  width: 90%;
  max-width: 400px;
  @media screen and (max-width: 768px) {
    width: 85%;
    max-width: 320px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/reject/rejectApprovalShow/rejectApprovalShow.vue